var map = {
	"./goldcoin/okxwallet-live.png": 98203,
	"./memetown/okxwallet-live.png": 40201,
	"./reflection/okxwallet-live.png": 82536,
	"./tapcoin/okxwallet-live.png": 52338
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5943;